export default "__VITE_ASSET__CI5Lm3q8__"